import React, {useEffect} from "react";
import PropTypes from "prop-types";
import styles from './YouTubeEmbed.scss';

const YouTubeEmbed = ({
						  embedId,
						  width = '100%',
						  height = '100%',
						  maxHeight = '540px',
						  title = 'YouTube video player',
						  frameBorder = 0,
						  allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture',
						  autoPlay = false
					  }) => {
	useEffect(() => {

		const iframeApiScriptId = 'youtube_iframe_api_script';
		let tag = document.getElementById(iframeApiScriptId);

		if (!tag) {
			tag = document.createElement('script');
			tag.src = 'https://www.youtube.com/iframe_api';
			tag.id = iframeApiScriptId;
			let firstScriptTag = document.getElementsByTagName('script')[0];
			firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
		}

	}, []);

	let url = `https://www.youtube.com/embed/${embedId}?enablejsapi=1`;
	if (autoPlay) {
		url = `https://www.youtube.com/embed/${embedId}?autoplay=1&enablejsapi=1`
	}

	return (
	  <div className={styles.videoResponsive}>
		  <iframe
			style={{width: width, height: height, maxHeight: maxHeight}}
			src={url}
			frameBorder={frameBorder}
			allow={allow}
			allowFullScreen
			title={title}
		  />
	  </div>
	);
}

YouTubeEmbed.propTypes = {
	embedId: PropTypes.string.isRequired,
	width: PropTypes.string,
	height: PropTypes.string,
	maxHeight: PropTypes.string,
	title: PropTypes.string,
	frameBorder: PropTypes.number,
	allow: PropTypes.string,
	autoPlay: PropTypes.bool
};

export default YouTubeEmbed;
